import req from './request.js'

export function orderList(data) {
  return req('get', '/api/order/orderlist', data)
}